import { InjectionToken, Provider } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { availableLocales } from '@locale/config/available-locales';
import { LocaleConfig } from '@locale/models/locale-config';
import { TUI_DATE_FORMAT, TuiDateFormatSettings } from '@taiga-ui/core';
import { map, Observable, shareReplay } from 'rxjs';
import { DEFAULT_LOCALE_CODE } from 'transloco.config';

export const LOCALE_CONFIG = new InjectionToken<Observable<LocaleConfig>>('LOCALE_CONFIG');
export const DATE_FNS_FORMAT = new InjectionToken<Observable<string>>('DATE_FNS_FORMAT');

const defaultLocale =
  availableLocales.find((loc: LocaleConfig) => loc.code === DEFAULT_LOCALE_CODE) ?? availableLocales[0];

const createLocaleConfig$ = (translocoService: TranslocoService): Observable<LocaleConfig> =>
  translocoService.langChanges$.pipe(
    map((currentLocale) => availableLocales.find((loc: LocaleConfig) => loc.code === currentLocale) ?? defaultLocale),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

export const provideLocaleConfig = (): Provider[] => [
  {
    provide: LOCALE_CONFIG,
    useFactory: createLocaleConfig$,
    deps: [TranslocoService],
  },
  {
    provide: DATE_FNS_FORMAT,
    useFactory: (localeConfig$: Observable<LocaleConfig>): Observable<string> =>
      localeConfig$.pipe(map((localeConfig) => localeConfig.dateFnsConfig.format)),
    deps: [LOCALE_CONFIG],
  },
  {
    provide: TUI_DATE_FORMAT,
    useFactory: (localeConfig$: Observable<LocaleConfig>): Observable<TuiDateFormatSettings> =>
      localeConfig$.pipe(map((localeConfig) => localeConfig.tuiConfig.format)),
    deps: [LOCALE_CONFIG],
  },
];
